export enum ForecastTypes {
  NEW = "new",
  UNLIKELY = "unlikely",
  UPDATED = "updated"
}

export interface Forecaster {
  accuracy: number;
  firstName: string;
  lastName: string;
  profileImage: string;
  profileUrl: string;
  forecasterTitle: string;
}

export interface Forecast {
  forecastCollegeName: string;
  forecastType: ForecastTypes;
  forecasterName: string;
  forecasterProfileUrl: string | null;
  id: number;
  noLongerLikely: boolean;
  previousCollegeName: string | null;
  previousForecastedCollegeId: number | null;
  previousForecastCancelled: boolean;
  prospectRecruitYear: number;
  prospectStars: number;
  prospectPositionAbbreviation: string;
  prospectProfileUrl: string;
  prospectName: string;
  prospectProfileImageUrl: string | null;
  stylizedForecastDate: string;
}
